/**
 * Asynchronously loads the component for NotAuthorizedPage
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./NotAuthorized'));
